import React from 'react'
import NotFound from '../notfound'

const NotFoundNl = () => {
    return <NotFound languageCode="nl" />
}

export default NotFoundNl
